<template>
    <span @click="send">{{text}}</span>
</template>

<script>
  import {systemService} from "../../../service/system";
  import axiosUtil from "../../utils/AxiosUtils.js";
  export default {
    name: "v-send-code",
    props: {
      value: {
        type: [String, Number],
        default: ''
      },
      docMobile: {
        type: [String, Number],
        default: ''
      },
      docPassword: {
        type: [String, Number],
        default: ''
      },
    },
    data() {
      return {
        time: 60,
        timer: null
      }
    },
    computed: {
      text() {
        return this.time === 60 ? '发送验证码' : `${this.time}s后重发`;
      }
    },
    methods: {
      async send() {
        let _this=this;
        if (this.time !== 60) return;
        let newPwd = _this.docPassword.toLowerCase(); // 密码不区分大小写
        let docNewPassword = sha512(hex_md5(newPwd) + newPwd);
        axiosUtil(
          {
            service: "smarthos.user.doc.pc.login.captchaCode",
            hosId: '1100000001',
            docMobile: _this.docMobile,
            docPassword:docNewPassword
          },
          ({code, obj, msg}) => {
            if (code === "0") {
              let cid=obj.cid;
              let value=obj.value;
              _this.$emit('ok', {cid, value});
              _this.djs();
            } else {
              this.$message.error(msg);
            }
          }
        );
      },
      clear() {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
      },
      djs() {
        this.time--;
        this.clear();
        if (this.time === 0) this.time = 60;
        else this.timer = setTimeout(() => {
          this.djs();
        }, 1000);
      }
    },
  }
</script>

<style scoped>

</style>
